import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";

const tips = [
  {
    icon: "ri-advertisement-line",
    color: "bg-red-100 text-red-700",
    title: "广告多不多，先看这几处",
    desc: "打开首页如果广告铺满、弹窗层叠，基本可以判断广告控制很差。真正的良心站首页通常干净，广告只在非阅读区域出现。",
  },
  {
    icon: "ri-shield-flash-line",
    color: "bg-secondary-100 text-secondary-900",
    title: "警惕诱导下载与付费套路",
    desc: "阅读中频繁弹出「下载 App 才能看」「付费解锁」的站点要格外警惕。正规免费阅读不需要这种套路，遇到就直接关闭。",
  },
  {
    icon: "ri-speed-line",
    color: "bg-accent-100 text-accent-900",
    title: "加载速度怎么测",
    desc: "用一个热门作品点进去连翻几页，看是否等待加载。图片走 CDN、页面轻量的站点通常加载流畅，加载慢的站点体验一定差。",
  },
  {
    icon: "ri-shield-check-line",
    color: "bg-primary-100 text-primary-700",
    title: "先试读再决定",
    desc: "不要一上来就注册或下载。先免费试读几话，体验广告、速度、画质后再决定是否长期使用，避免被套路。",
  },
  {
    icon: "ri-global-line",
    color: "bg-accent-100 text-accent-900",
    title: "留意弹窗来源",
    desc: "不要点击来路不明的弹窗和跳转链接，避免误入钓鱼或捆绑下载页面。广告多的站点尤其要管住手。",
  },
  {
    icon: "ri-heart-line",
    color: "bg-red-100 text-red-700",
    title: "尊重版权，支持正版",
    desc: "长期稳定的良心站离不开正版支持。遇到喜欢的作品，优先选择正版渠道，平台和创作者才能持续输出好内容。",
  },
];

const redFlags = [
  "广告弹窗层叠、关闭按钮藏得深",
  "反复诱导下载 App 或安装插件",
  "阅读中强制跳转到其他推广页",
  "翻页卡顿、图片加载极慢",
  "频繁要求付费「解锁」本该免费的内容",
];

export default function Guide() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6">
        <nav className="flex items-center gap-1.5 text-sm text-foreground-500">
          <Link to="/" className="hover:text-primary-600">首页</Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-foreground-900">避雷指南</span>
        </nav>

        <div className="mt-6 max-w-2xl">
          <h1 className="font-display text-3xl text-foreground-950 md:text-4xl">漫画网站避雷指南</h1>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            漫画网站千千万，坑也不少。这篇避雷指南帮你建立判断标准，从广告控制到加载速度，一眼识别良心站与坑爹站，看漫画更省心、少踩坑。
          </p>
        </div>

        {/* red flags */}
        <section className="mt-8 overflow-hidden rounded-2xl bg-foreground-950">
          <div className="flex flex-col gap-6 p-6 md:flex-row md:items-center md:justify-between md:p-8">
            <div>
              <h2 className="flex items-center gap-2 font-display text-xl text-background-50 md:text-2xl">
                <i className="ri-alert-line text-red-500"></i>
                遇到这些信号，请立即绕开
              </h2>
              <ul className="mt-4 space-y-2.5">
                {redFlags.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-sm text-background-100/90">
                    <i className="ri-close-circle-line mt-0.5 text-red-500"></i>
                    {f}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>

        {/* tips grid */}
        <section className="mt-12">
          <h2 className="font-display text-2xl text-foreground-950 md:text-3xl">避雷实用要点</h2>
          <p className="mt-2 text-sm text-foreground-600">从入门到进阶，帮你快速建立自己的判断标准</p>
          <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {tips.map((t) => (
              <div key={t.title} className="rounded-xl border border-background-200 bg-background-50 p-5">
                <span className={`flex h-11 w-11 items-center justify-center rounded-lg text-lg ${t.color}`}>
                  <i className={t.icon}></i>
                </span>
                <h3 className="mt-4 font-display text-lg text-foreground-950">{t.title}</h3>
                <p className="mt-2 text-sm leading-6 text-foreground-600">{t.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* CTA */}
        <section className="mt-12 overflow-hidden rounded-2xl border border-background-200 bg-background-100 p-6 md:p-8">
          <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-center">
            <div>
              <h2 className="font-display text-xl text-foreground-950 md:text-2xl">想直接看结论？</h2>
              <p className="mt-2 text-sm leading-6 text-foreground-600">
                我们已经把各个站点的广告、速度、良心度都评好了，直接看榜单更省事。
              </p>
            </div>
            <Link
              to="/rankings"
              className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-trophy-line"></i>
              查看综合榜单
            </Link>
          </div>
        </section>
      </main>

      <Footer />
      <BackToTop />
    </div>
  );
}